import { Link, useSearchParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { Button } from '@/components/Button';

export function VerifyEmail() {
  const [params] = useSearchParams();
  const [state, setState] = useState<'pending' | 'ok' | 'error'>('pending');

  useEffect(() => {
    // The /api/Clients/confirm endpoint redirects on success, so reaching this
    // page typically means we landed back here after a successful verify.
    // Treat presence of a verified=1 query as success; bare load is a "thanks
    // for clicking, your email is verified" state.
    const verified = params.get('verified');
    setState(verified === '0' ? 'error' : 'ok');
  }, [params]);

  return (
    <div className="w-full max-w-md text-center">
      {state === 'ok' ? (
        <>
          <h1 className="font-display text-h1 font-bold">Email verified</h1>
          <p className="mt-3 text-body text-text-secondary">
            Thanks. You're all set.
          </p>
          <div className="mt-8">
            <Button asChild size="lg">
              <Link to="/dashboard">Go to dashboard</Link>
            </Button>
          </div>
        </>
      ) : state === 'error' ? (
        <>
          <h1 className="font-display text-h1 font-bold">Verification failed</h1>
          <p className="mt-3 text-body text-text-secondary">
            The verification link is invalid or has expired. Sign in to resend
            the verification email from your account settings.
          </p>
          <div className="mt-8">
            <Button asChild size="lg">
              <Link to="/login">Back to sign in</Link>
            </Button>
          </div>
        </>
      ) : (
        <p className="text-body text-text-secondary">Verifying…</p>
      )}
    </div>
  );
}
